import moment from 'moment-timezone'

const normalizeTime = (timeStr) => {
  if (!timeStr) return ''
  const trimmed = timeStr.trim()
  if (/^\d{2}:\d{2}$/.test(trimmed)) return trimmed
  return ''
}

export const formatUtcRsvpForDisplay = (utcDate, utcTime) => {
  if (!utcDate || !utcTime) return null

  const time = normalizeTime(utcTime)
  if (!time) return null

  const utcMoment = moment.utc(`${utcDate} ${time}`, 'YYYY-MM-DD HH:mm', true)
  if (!utcMoment.isValid()) return null

  const local = utcMoment.local()
  return {
    date: local.format('MMMM Do, YYYY'),
    time: local.format('h:mm a').replace('am', 'a.m.').replace('pm', 'p.m.'),
  }
}
